import * as Sentry from '@sentry/browser'
import loadJS from 'load-js'
import styles from './recaptcha.module.scss' // eslint-disable-line no-unused-vars

const {
  REACT_APP_LGW_RECAPTCHA_KEY: KEY
} = process.env

const loadPromise = loadJS(`https://www.google.com/recaptcha/api.js?render=${KEY}`)

let loaded = false

export const getInstance = async () => {
  if (loaded) {
    return window.grecaptcha
  }

  try {
    await loadPromise
    loaded = true
    return window.grecaptcha
  } catch (e) {
    Sentry.captureException(e)

    return {
      execute: () => Promise.resolve(e.message)
    }
  }
}

export const execute = async params => {
  const instance = await getInstance()
  return instance.execute(KEY, params)
}
